var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-area"},[_c('label',{staticClass:"text-area__label d-block mb-1"},[_vm._v(_vm._s(_vm.label))]),_c('v-textarea',{attrs:{"flat":"","solo":"","full-width":"","auto-grow":"","height":_vm.height,"value":_vm.value,"placeholder":_vm.placeholder},on:{"input":_vm.updateTextArea}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }